module.exports = __webpack_public_path__ + "static/img/h12.688f5f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/h12.jpg
// module id = zP3U
// module chunks = 0